module.exports = __webpack_public_path__ + "img/education.eef26ec5.png";